import { n as native } from './native-ByXg-_oZ.js';
import { r as rng } from './rng-k-Tk_XAp.js';
import { u as unsafeStringify } from './stringify-D0VVnI5R.js';

function v4(options, buf, offset) {
  var _ref, _options$random, _options$rng, _options;
  if (native.randomUUID && true && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = (_ref = (_options$random = options.random) !== null && _options$random !== void 0 ? _options$random : (_options$rng = (_options = options).rng) === null || _options$rng === void 0 ? void 0 : _options$rng.call(_options)) !== null && _ref !== void 0 ? _ref : rng();
  if (rnds.length < 16) {
    throw new Error('Random bytes length must be >= 16');
  }
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;
  return unsafeStringify(rnds);
}

export { v4 as v };
//# sourceMappingURL=v4-CYEyAeRz.js.map
